import { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
import { Link, useNavigate } from 'react-router-dom';
import UsuarioModal from './components/modals/UsuarioModal';
import TableContainer from './components/TableContainer';
import DataTable from './components/DataTable';
import PaginationBar from './components/PaginationBar';
import ResponsiveShadow from './components/ResponsiveShadow';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import ConfirmModal from './components/modals/ConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import usePagination10 from './components/hooks/usePagination10';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import Toolbar from './components/Toolbar';
import LoadingModal from './components/modals/LoadingModal';

// Certifique-se de que o CSS para .full-screen-div ainda está sendo importado
// .full-screen-div { display: flex; flex-direction: column; min-height: 100vh; }

function Usuarios() {
  // ... todo o seu state, useEffects e funções (NÃO MUDA NADA AQUI) ...
  const [Usuarios, setUsuarios] = useState([]);
  const [atualizar, setAtualizar] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState(''); // Estado do filtro
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const isMaster = JSON.parse(localStorage.getItem('user') || '{}')?.role === 'MASTER';
  const alvoPrivilegiado = !!usuarioSelecionado && ['ADMIN', 'MASTER'].includes(usuarioSelecionado.role);

  useEffect(() => {
    if (!isMaster) {
      navigate('/home');
    }
  }, [isMaster, navigate]);
  const totalItems = Usuarios.length;
  const { setPagination } = usePagination10(totalItems);

  // Função para filtrar os fabricantes com base na busca
  const normalizeString = str => {
    if (!str) return '';
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  // Filtra os fabricantes com base no termo de busca
  const usuariosFiltrados = Usuarios.filter(usu => {
    const normalizedBusca = normalizeString(filtro);
    return (
      normalizeString(usu.nome).includes(normalizedBusca) ||
      normalizeString(usu.cpf).includes(normalizedBusca) ||
      normalizeString(usu.login).includes(normalizedBusca)
    );
  });

  const selectedUsuarios = usuariosFiltrados.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();

  // Modal state for Usuario
  const [showUsuarioModal, setShowUsuarioModal] = useState(false);
  const [usuarioForm, setUsuarioForm] = useState({ cpf: '', nome: '', login: '', senha: '', situacao: '', role: '', cargo: '', email: '' });
  const [emailError, setEmailError] = useState('');

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL.USUARIO}/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        setUsuarios(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter usuários:', error);
        const status = error?.response?.status;
        if (status === 401) {
          navigate('/');
        } else {
          showDefaultModal('error', error.response?.data?.message || error.message || 'Erro ao obter usuários.');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [atualizar]);

  function handleDelete(cpf) {
    showConfirmModal('delete', () => handleConfirmDelete(cpf));
  }

  function handleConfirmDelete(cpf) {
    const loggedUser = JSON.parse(localStorage.getItem('user'));
    const loggedUserCpf = loggedUser?.cpf;

    if (cpf === loggedUserCpf) {
      showDefaultModal('error', 'Você não pode excluir a si mesmo.');
      return;
    }

    axios
      .get(`${API_BASE_URL.VINCULO}/exists_cpf/` + cpf, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        if (result.data.exists) {
          showDefaultModal(
            'error',
            'Este usuário possui vínculos e não pode ser excluído. Exclua os vínculos antes de tentar novamente.'
          );
        } else {
          axios
            .delete(`${API_BASE_URL.USUARIO}/delete/` + cpf, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then(result => {
              setAtualizar(result);
              showDefaultModal(
                'success',
                'O registro foi excluído com sucesso!'
              );
            })
            .catch(error => {
              console.error('Erro ao excluir usuário:', error);
              showDefaultModal('error', 'Erro ao excluir o registro!');
            });
        }
      })
      .catch(error => {
        console.error('Erro ao verificar vínculos:', error);
        const status = error?.response?.status;
        if (status === 401) {
          setTimeout(() => navigate('/'), 0);
        } else {
          showDefaultModal('error', error.response?.data?.message || error.message || 'Erro ao verificar vínculos.');
        }
      });
  }

  // Handlers to open modal instead of navigating
  function handleOpenNewUsuario() {
    setUsuarioForm({ cpf: '', nome: '', login: '', senha: '', situacao: '', role: '', cargo: '', email: '' });
    setEmailError('');
    setShowUsuarioModal(true);
  }

  function handleOpenEditUsuario() {
    if (!usuarioSelecionado) return;
    setUsuarioForm({ ...usuarioSelecionado });
    setEmailError('');
    setShowUsuarioModal(true);
  }

  function handleUsuarioChange(e) {
    const { name, value } = e.target;
    setUsuarioForm(prev => ({ ...prev, [name]: value }));
    if (name === 'email') {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setEmailError(value && !re.test(value) ? 'E-mail inválido' : '');
    }
  }

  function handleUsuarioSubmit(ev) {
    ev.preventDefault();
    // validate CPF minimal
    const token = localStorage.getItem('token');
    const payload = { ...usuarioForm, cpf: usuarioForm.cpf.replace(/\D/g, '') };
    if (!isMaster && ['ADMIN', 'MASTER'].includes(payload.role)) {
      showDefaultModal('error', 'Apenas o usuário MASTER pode gerenciar usuários administradores.');
      return;
    }
    if (!payload.email || !payload.email.trim()) {
      setEmailError('O email é obrigatório para permitir a recuperação de senha.');
      return;
    }
    axios.post(`${API_BASE_URL.USUARIO}/salvar`, payload, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        setAtualizar(Date.now());
        setShowUsuarioModal(false);
        showDefaultModal('success', 'O registro foi salvo com sucesso!');
      })
      .catch(err => {
        showDefaultModal('error', err.response?.data?.message || err.message || 'Erro ao salvar usuário');
      });
  }

  return (
    <Layout>
      <LoadingModal show={isLoading} />
      <ResponsiveShadow>
        <PageHeader title="Usuários Cadastrados" icon="bi-people" />
        <PageContent>
          <Toolbar
            onNew={handleOpenNewUsuario}
            onEdit={isMaster || !alvoPrivilegiado ? handleOpenEditUsuario : undefined} disableEdit={!usuarioSelecionado}
            onDelete={isMaster || !alvoPrivilegiado ? () => usuarioSelecionado && handleDelete(usuarioSelecionado.cpf) : undefined} disableDelete={!usuarioSelecionado}
          >
              <button className="btn btn-info btn-sm botao-igual d-inline-flex align-items-center centralizar-se-impar" disabled={!usuarioSelecionado} onClick={() => usuarioSelecionado && navigate('/usuario_vinculos', { state: { usuario: usuarioSelecionado } })} title="Vincular usuário selecionado">
                <i className="bi bi-link-45deg me-1"></i>Vincular
              </button>
            <div className="input-group input-group-sm toolbar-search">
              <span className="input-group-text bg-light"><i className="bi bi-search"></i></span>
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por CPF, Nome ou Login"
                value={filtro}
                onChange={e => setFiltro(e.target.value.toUpperCase())}
                style={{ textTransform: 'uppercase', fontVariant: 'normal' }}
              />
            </div>
          </Toolbar>

          <TableContainer isLoading={false}>
              <DataTable head={
                  <tr>
                    <th scope="col" style={{ width: '3rem' }}>#</th>
                    <th scope="col">CPF</th>
                    <th scope="col">Nome</th>
                    <th scope="col">Login</th>
                    <th scope="col">Situação</th>
                  </tr>
                }>
              <tbody>
                {selectedUsuarios.map((usu, idx) => (
                    <tr
                      key={usu.cpf}
                      className={
                        usuarioSelecionado &&
                        usuarioSelecionado.cpf === usu.cpf
                          ? 'table-primary'
                          : ''
                      }
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        if (
                          usuarioSelecionado &&
                          usuarioSelecionado.cpf === usu.cpf
                        ) {
                          setUsuarioSelecionado(null); // Desseleciona se já estiver selecionado
                        } else {
                          setUsuarioSelecionado(usu); // Seleciona o usuário
                        }
                      }}
                    >
                      <td>{setPagination.startIndex + idx + 1}</td>
                      <td>{usu.cpf}</td>
                      <td>{usu.nome}</td>
                      <td>{usu.login}</td>
                      <td>{usu.situacao}</td>
                    </tr>
                  ))}
              </tbody>
            </DataTable>
          </TableContainer>
        </PageContent>

        <PaginationBar setPagination={setPagination} />
      </ResponsiveShadow>

      <ConfirmModal {...setConfirmModal} />
      <DefaultModal {...setDefaultModal} />
      <UsuarioModal show={showUsuarioModal} onClose={() => setShowUsuarioModal(false)} onSubmit={handleUsuarioSubmit} form={usuarioForm} handleChange={handleUsuarioChange} emailError={emailError} isMaster={isMaster} />
    </Layout>
  );
}

export default Usuarios;
